/** Business constants copied from the prototype. Never change without owner approval (task.md §7.3). */
export const DEFAULT_PURCHASE_MARGIN = 30;
export const LOW_STOCK_THRESHOLD = 5;
export const LATE_MINUTES = 10;
export const EARLY_LEAVE_TOLERANCE_MINUTES = 10;
export const SALE_DOUBLE_CLICK_MS = 1200;
export const TASK_PROGRESS_STEPS = [0, 25, 50, 75, 100] as const;
export type TaskProgress = (typeof TASK_PROGRESS_STEPS)[number];
export const TASK_HISTORY_CAP = 30;
export const ACTIVITIES_VISIBLE = 1000;
export const MAX_TABLE_ROWS = 250;
export const ANNUAL_LEAVE_DAYS = 28;
export const ROTATION_START_DATE = '2026-08-24';
export const SUNDAY_WORKERS_COUNT = 2;
export const BREAK_MINUTES = 30;
export const SUNDAY_SHIFT = { start: '08:00', end: '15:00' } as const;
export const MORNING_WINDOW = { start: '08:00', end: '10:00' } as const;
export const EVENING_WINDOW = { start: '17:00', end: '19:00' } as const;
export const MIN_COVERAGE = 2;
export const PURCHASE_DRAFT_DEBOUNCE_MS = 600;
export const TIMEZONE = 'Europe/Belgrade';
export const LOCALE = 'sq-AL';
export const AUTH_EMAIL_DOMAIN = 'agrogruda.local';
export const USERNAME_MIN = 3;
export const PASSWORD_MIN = 4;

export const UNITS = ['copë', 'kg', 'litër', 'metër', 'paketë', 'palë', 'thes', 'komplet', 'dhëmbë'] as const;
export type Unit = (typeof UNITS)[number];

export const VAT_RATES = [0, 8, 18] as const;
export type VatRate = (typeof VAT_RATES)[number];
export const DEFAULT_VAT: VatRate = 18;

/** `delivery` is NEW: a worker who carries orders from the depo and uses the system for nothing else. */
export const ROLES = ['admin', 'staff', 'delivery'] as const;
export type Role = (typeof ROLES)[number];
/** Prototype ROLE_LABELS (line 3082) — displayed in the sidebar, the users modal and activity details. */
export const ROLE_LABELS: Record<Role, string> = {
  admin: 'Drejtor / Administrator',
  staff: 'Staf',
  delivery: 'Punëtor dorëzimesh',
};

export const STOCK_LOCATIONS = ['local', 'warehouse'] as const;
export type StockLocation = (typeof STOCK_LOCATIONS)[number];

export const MOVEMENT_REASONS = [
  'purchase',
  'sale',
  'debt',
  'transfer_in',
  'transfer_out',
  'adjustment',
  'import',
  'return',
] as const;
export type MovementReason = (typeof MOVEMENT_REASONS)[number];

export const ACTIVITY_TYPES = [
  'sale',
  'purchase',
  'stock',
  'debt',
  'payment',
  'task',
  'request',
  'delivery',
  'attendance',
  'auth',
] as const;
export type ActivityType = (typeof ACTIVITY_TYPES)[number];

export const PAGES = [
  'dashboard',
  'sales',
  'deliveries',
  'purchases',
  'suppliers',
  'stock',
  'debts',
  'tasks',
  'whatsapp',
  'attendance',
  'reports',
  'settings',
] as const;
export type Page = (typeof PAGES)[number];

/**
 * ROLE_PAGES. The prototype let every role see every page. The settings (printer, company data, the
 * rules the whole shop runs on) are now the administrator's alone, and a delivery worker's login opens
 * his deliveries and nothing else.
 */
export const ROLE_PAGES: Record<Role, readonly Page[]> = {
  admin: PAGES,
  staff: PAGES.filter((p) => p !== 'settings'),
  delivery: ['deliveries'],
};
